module.exports = __webpack_public_path__ + "img/prioritas_vippack.2ea4b721.png";